import { intersectionViewportObserver } from '@Foundation/utilities/intersectionViewportObserver';
import { debounce } from '../../utilities/timing';

export const getBackground = (backgrounds, windowWidth) => {

  if (typeof backgrounds === 'string') {
    return backgrounds;
  }

  if (!backgrounds || typeof backgrounds !== 'object') {
    return '';
  }

  const currentWidth = windowWidth || document.documentElement.clientWidth;
  const keys = Object.keys(backgrounds).reverse();
  const lastMatchingKey = keys.filter(key => currentWidth >= key).shift();
  return backgrounds[lastMatchingKey];
};

export const srcset = {
  name: 'srcset',
  inserted: (el, binding) => {
    const updateBackground = () => {
      const url = getBackground(binding.value);

      if (el.tagName.toLowerCase() !== 'img') {
        el.style.backgroundImage = `url('${url}')`;

        const img = el.querySelector('img');

        if (img) {
          img.src = url;
        }
      } else {
        el.src = url;
      }
    };

    intersectionViewportObserver(el, { checkIsVisible: false }).then(() => {
      updateBackground();

      el.listener = debounce(updateBackground, 200);
      window.addEventListener('resize', el.listener);

      setTimeout(() => {
        el.classList.add('-loaded');
      }, 100);
    });
  },

  unbind(el) {
    if (el.listener) {
      window.removeEventListener('resize', el.listener);
    }
  }
};

export const lazy = {
  name: 'lazy',
  inserted: (el) => {
    const updateBackground = () => {
      const url = getBackground(el.getAttribute('data-lazy'));
      const tagType = el.tagName.toLowerCase();

      if (tagType !== 'img') {
        el.style.backgroundImage = `url('${url}')`;

        const img = el.querySelector('img');

        if (img) {
          img.src = url;
        }
      } else {
        el.src = url;

        if (el.closest('picture')) {
          const sources = el.parentNode.querySelectorAll('source');
          const da = 'data-srcset';
          // eslint-disable-next-line sonarjs/no-identical-functions
          sources.forEach(function (source) {
            if (source.getAttribute(da)) {
              source.setAttribute('srcset', source.getAttribute(da));
              source.removeAttribute(da);
            }
          });
        }
      }
    };

    // eslint-disable-next-line sonarjs/no-identical-functions
    intersectionViewportObserver(el, { checkIsVisible: false }).then(() => {
      updateBackground();

      el.listener = debounce(updateBackground, 200);
      window.addEventListener('resize', el.listener);

      setTimeout(() => {
        el.classList.add('-loaded');
      }, 100);
    });
  },

  // eslint-disable-next-line sonarjs/no-identical-functions
  unbind(el) {
    if (el.listener) {
      window.removeEventListener('resize', el.listener);
    }
  },
};
